const getPayment = ({ state, id }) => {
  const { payments } = state;
  return payments && payments.find(payment => payment.id === id);
};

export default {
  getAllPayments: state => state.payments,
  getPayment: state => id => getPayment({ state, id }),
};
